import { CategoriesActions, ECategoriesActions } from '../actions/category.actions';
import { initialCategoriesState, ICategoriesState } from '../states/category.state';

export const CategoriesReducers = (
  state = initialCategoriesState,
  action: CategoriesActions
): ICategoriesState => {
  switch (action.type) 
  {
    case ECategoriesActions.GetCategoriesSuccess: {
      return {
        ...state,
        Categories:{...action.payload}
      };
    }
    default:
      return state;
  }
};
